import { AccountDatasource } from './../../../../lib/user_app/datasources/account_datasource';
import { ILocalDatabase } from 'utility-ts-database';

class UserSessionTimerController {
  private calculateTimeout(expireTime: number): string {
    return Math.round((expireTime - Date.now()) / 1000) + 's';
  }

  private DEFAULT_TIMEOUT = this.calculateTimeout(this.ngAccountDatasource.account.expire_time);
  private timeout = this.DEFAULT_TIMEOUT;

  constructor(
    private ngAccountDatasource: AccountDatasource,
    private localDatabase: ILocalDatabase,
    private $state: ng.ui.IStateService,
    private sessionTimerDelegate: any
  ) {}

  onTick(count: number): void {
    // NOOP
  }

  warningCallBack(): Promise<void> {
    const userSessionDelegate = this.sessionTimerDelegate.handle('userSession');
    return this.localDatabase
      .open()
      .then(() => {
        return this.localDatabase.get(this.ngAccountDatasource.account.id);
      })
      .then((account) => {
        if (account.expire_time !== this.ngAccountDatasource.account.expire_time) {
          this.timeout = this.calculateTimeout(account.expire_time);
          this.ngAccountDatasource.account.expire_time = account.expire_time;
          userSessionDelegate.restartSession(this.timeout);
        } else {
          this.timeout = this.DEFAULT_TIMEOUT;
          this.ngAccountDatasource.account.is_transfer_counselor ||
          this.ngAccountDatasource.account.is_transfer_admin ||
          this.ngAccountDatasource.account.is_transfer_analytics_user
            ? this.$state.go('admin.modal.timeout')
            : this.$state.go('my.modal.timeout');
        }
      });
  }
}

angular
  .module('capability-ng-global')
  .controller('userSessionTimerController', UserSessionTimerController)
  .component('userSessionTimer', {
    template:
      '<session-timer wait-time="{{ $ctrl.timeout }}" on-tick="$ctrl.onTick(count)" on-end="$ctrl.warningCallBack()" handle="userSession"></session-timer>',
    controller: 'userSessionTimerController'
  });



// WEBPACK FOOTER //
// ./app/lib/global/components/user_session_timer/user_session_timer_component.ts